import "./App.css";
import Notifications from "./components/Notifications/Notifications";

function App() {
  return (
    <>
      <Notifications />
    </>
  );
}

export default App;
